const filtersEn = {
    "all_guests": "All Guests",
    "subscribed_guests": "Newsletter Subscribers",
    "not_subscribed_guests": "No marketing consent",
    "last_reservation": "Last Reservation",
    "last_monthly_filters": {
        "-1": "Anytime",
        "1": "Last 1 month",
        "3": "Last 3 months",
        "6": "Last 6 months",
        "12": "Last 12 months",
        "custom": "Custom period",
    },
    "custom_period": "Custom period",
    "pick_both_dates": "Pick both the start and the end of the period.",
    "visit_count": "Visit count",
    "visit_count_value": "Number of visits",
    "visit_count_operators": {
        "any": "Any",
        "eq": "Exactly",
        "gte": "At least",
        "lte": "At most",
        "gt": "More than",
        "lt": "Less than",
    },
}

export default filtersEn;
